'use strict';
require('../modules/esnext.string.is-well-formed');
require('../modules/esnext.string.to-well-formed');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/well-formed-unicode-strings.js
// module id = 988
// module chunks = 29